import React from "react";
import { useTranslation } from "react-i18next";
import gamerjiLogo from "../assets/images/gamerjilogo.png";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#070b28] text-white text-center font-proxima">
      {/* Gamerji Logo Centered */}
      <div className="flex justify-center">
        <img
          src={gamerjiLogo}
          alt="Gamerji Logo"
          className="w-[12rem] h-[6rem] object-contain mb-[-10px]"
        />
      </div>

      {/* Footer Links */}
      <div className="text-sm text-gray-300 mb-4 space-x-4 rtl:space-x-reverse">
        <Link to="/about-us" className="hover:underline">
          {t("aboutUs")}
        </Link>
        <span>|</span>
        <Link to="/tndc" className="hover:underline">
          {t("termsConditions")}
        </Link>
        <span>|</span>
        <Link to="/pp" className="hover:underline">
          {t("privacyPolicy")}
        </Link>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#F13232] py-2 text-xs mt-4">
        {t("footer.copyright")}
      </div>
    </footer>
  );
};

export default Footer;
